import { createContext, useReducer } from 'react';

import Reducer from '@/lib/reducers';

import type { Action, State } from './Store.d';

const initialState: State = {
	entryPage: '',
	currentPage: '',
	pageTheme: '',
	productClass: '',
	pricingText: '',
	showProductOnRight: false,
	hideAlert: true,
	alertTitle: 'Fehler',
	alertMessage: 'Es ist ein Fehler aufgetreten',
	// TODO: Discuss whether to use the new dialog component for existing alerts
	dialog: {
		title: 'Fehler',
		body: 'Es ist ein Fehler aufgetreten',
		isHidden: true
	},
	isLoggedIn: false,
	isFreePurchase: false,
	disableOnSubmit: false,
	showVoucherInput: false,
	voucher: undefined,
	user: {
		email: '',
		password: '',
		tokenID: '',
		ip: '',
		phone: {
			number: '',
			countryCode: ''
		},
		acceptMassmail: true
	},
	address: {
		delivery: {
			zip: '',
			city: '',
			street: '',
			streetID: ''
		}
	},
	bundle: null,
	payment: {
		sessionToken: '',
		paymentMethod: 'notset',
		reusePaymentMethod: false,
		accountReference: ''
	},
	autocompletions: {
		zipCodes: [],
		cities: [],
		streets: []
	},
	supporter: {
		minimumAmount: 3,
		tiers: {
			low: '25',
			mid: '50',
			high: '100'
		},
		selection: {
			period: 'single',
			tier: '25'
		}
	},
	bi: {
		userToken: false
	},
	upgrade: {
		movableSubscription: false,
		message: ''
	},
	challengeRequired: {},
	eligibleForTrial: undefined,
	restoredFromStorage: false
};

const Context = createContext<[State, React.Dispatch<Action>]>([initialState, () => null]);

type StoreProps = {
	children: React.ReactNode;
};

/**
 * Store component
 * @param {*} props
 * @returns {ReactElement}
 */
const Store = ({ children }: StoreProps) => {
	const [state, dispatch] = useReducer(Reducer, initialState);

	return <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>;
};

export { Context, Store };
